export var LocationEnum;
(function (LocationEnum) {
    LocationEnum[LocationEnum["Main"] = 1] = "Main";
    LocationEnum[LocationEnum["Common"] = 2] = "Common";
})(LocationEnum || (LocationEnum = {}));
//# sourceMappingURL=index.js.map